if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
        super();
        this.productHandle = this.dataset.productHandle;
        this.recentlyViewed = [];
        this.filteredProducts = [];
    }

    connectedCallback() {
      this.updateLocalStorage();
      if (!this.recentlyViewed) return;

      this.populateRecentlyViewed();
    }

    async populateRecentlyViewed() {                
      for (let i = 0; i < this.recentlyViewed?.length; i++) {
        const productHandle = this.recentlyViewed[i];
        if (i > 8 || !productHandle) break;
        
        if (productHandle !== this.productHandle) {
          await fetch(`/products/${productHandle}.json`)
            .then((response) => {
              if (!response.ok) return;
              return response.json();
            })
            .then((data) => {
              const product = data?.product;
              if (!product) return;
              const tags = product.tags.split(',').map(item => item.trim())
              const bannedtags = ['base-product', 'hide_product']
                          
              if (!bannedtags.some(i => tags.includes(i))) this.filteredProducts.push(product.handle);
            })
            .catch((err) => console.error(`Recently Viewed Products Module: ${err}`));
        }
      }
      
      if (!this.filteredProducts.length) {
        this.closest('.shopify-section')?.remove();
        return;
      }
      
      this.innerHTML = `
        <ul class="hidden md:grid grid-cols-5 gap-4">
          ${this.filteredProducts.slice(0, 5).map((product) => `
            <li class="flex items-stretch">
              <intersection-loader 
                data-url="/products/${product}" 
                data-section-id="product-tile"
              ></intersection-loader>
            </li>
          `).join('')}
        </ul>
        <div class="relative md:hidden mx-4">
          <swiper-carousel 
            data-space-between="8"
            data-slides-per-view-mobile="1.5"
          >
            <div class="swiper-wrapper">
              ${this.filteredProducts.slice(0, 4).map((product) => `
                <div class="swiper-slide">
                  <intersection-loader 
                    data-url="/products/${product}" 
                    data-section-id="product-tile"
                  ></intersection-loader>    
                </div>
              `).join('')}
            </div>
             <button 
                class="button-slider absolute left-0 z-[2] top-1/2 transform -translate-x-2 md:-translate-x-1/2 -translate-y-full disabled:hidden" 
                data-prev
              >
                <svg class="transform -scale-x-100" xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
                </svg>
              </button>
              
              <button 
                class="button-slider absolute right-0 z-[2] top-1/2 transform translate-x-2 md:translate-x-1/2 -translate-y-full disabled:hidden" 
                data-next
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
                </svg>
              </button>
          </swiper-carousel>
        </div>
      `;
    }

    updateLocalStorage() {
      if (localStorage.getItem('recentlyViewedProducts')) {
        this.recentlyViewed = [...new Set([...localStorage.getItem('recentlyViewedProducts')?.split(',')])].slice(0, 5) ?? [];
      }

      if ((this.recentlyViewed[this.productHandle]) || !this.productHandle) return;
      localStorage.setItem('recentlyViewedProducts', `${this.productHandle}${this.recentlyViewed ? `,${this.recentlyViewed}` : ''}`);
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}